<template>
  <div
    class="rs-favorite"
    :title="tooltip ? '' : description"
    @click="handleClick"
  >
    <label
      :id="'fave_' + id"
      class="rs-favorite__label"
      :for="'fave_' + id"
    >
      <i :class="value === trueValue ? `fa-lg fas fa-${icon} rs-favorite__icon--active` : `fa-lg fal fa-${icon} rs-favorite__icon`" />

      <span
        v-if="label"
        class=" label"
        :class="{ 'text-white': setLabelWhite }"
      >{{ label }}
      </span>
    </label>
    <RsTooltip
      v-if="tooltip"
      :target="'fave_' + id"
      :title="tooltip"
      position="bottom"
      :delay="{ show: 200 }"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsFavorite',
  props: {
    icon: {
      type: String,
      default: 'bookmark',
    },
    description: { type: String, default: 'Toggle Featured' },
    trueValue: {
      type: [String, Number, Boolean ],
      default: true,
    },
    falseValue: {
      type: [String, Number, Boolean ],
      default: false,
    },
    id: [String, Number],
    label: String,
    name: String,
    value: {
      type: [String, Number, Boolean ],
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltip: String,
    setLabelWhite: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      if (!this.disabled) {
        this.$emit('input', this.value === this.trueValue ? this.falseValue : this.trueValue);
      }
    },
  },
});
</script>
<style lang="scss" scoped>
@import '@/styles/_variables.scss';
.rs-favorite {
  position: relative;
  margin: 0;
  &__icon {
    display: inline-block;
    color: $tertiary-gray;
    &--active {
      color: $secondary-color;
    }
  }
  &__label {
    margin: 0;
    padding-bottom: 6px;
    &:hover {
      cursor: pointer;
    }
  }
  .label {
    margin-left: 0.6rem;
  }
}
</style>
